import InputPhoto from "./desktop/InputPhoro";

export default InputPhoto;